import { render } from "./ReactivePayment.vue?vue&type=template&id=4b1469ac"
import script from "./ReactivePayment.vue?vue&type=script&lang=js"
export * from "./ReactivePayment.vue?vue&type=script&lang=js"

import "./ReactivePayment.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__